import { render } from "./ProjectObslog.vue?vue&type=template&id=3f7bf988&scoped=true"
import script from "./ProjectObslog.vue?vue&type=script&lang=js"
export * from "./ProjectObslog.vue?vue&type=script&lang=js"

import "./ProjectObslog.vue?vue&type=style&index=0&id=3f7bf988&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7bf988"]])

export default __exports__